(function () {
  var categoriaAttiva = {};
  var listenersAggiunti = {};

  function injectFilterStyle(sectionId, optionIndex, categoria) {
    var styleId = 'misura-filter-style-' + sectionId;
    var el = document.getElementById(styleId);
    if (!el) {
      el = document.createElement('style');
      el.id = styleId;
      document.head.appendChild(el);
    }
    el.textContent =
      '#Option-' + sectionId + '-' + optionIndex + ' option:not([data-categoria="' + categoria + '"]) { display: none; }';
  }

  function getMisuraFromVariant(sectionId, optionIndex) {
    var variantJson = document.querySelector('[data-selected-variant]');
    if (!variantJson) return null;
    try {
      var variant = JSON.parse(variantJson.textContent);
      if (!variant) return null;
      return variant.options[optionIndex];
    } catch (e) {
      return null;
    }
  }

  function getCategoriaFromVariant(sectionId) {
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');
    if (!variantId) return null;
    var mapEl = document.getElementById('misura-map-' + sectionId);
    if (!mapEl) return null;
    try {
      var map = JSON.parse(mapEl.textContent);
      var dawnSelect = document.querySelector('select[id^="Option-' + sectionId + '"]');
      if (!dawnSelect) return null;
      var selectedOpt = dawnSelect.options[dawnSelect.selectedIndex];
      if (!selectedOpt) return null;
      return map[selectedOpt.value] || null;
    } catch (e) {
      return null;
    }
  }

  // daUtente: chiamata dal click su una categoria. Il JSON data-selected-variant
  // può essere vecchio mentre una richiesta di Dawn è in corso, quindi non basta
  // a decidere che la misura è già quella giusta.
  function applicaFiltro(sectionId, optionIndex, categoria, daUtente) {
    var misuraCorretta = getMisuraFromVariant(sectionId, optionIndex);

    // Desktop <select>
    var selectEl = document.getElementById('Option-' + sectionId + '-' + optionIndex);
    if (selectEl) {
      injectFilterStyle(sectionId, optionIndex, categoria);

      // Safari desktop ignora display:none sulle <option> e le mostra grigie:
      // le opzioni fuori categoria vengono quindi tolte dalla select e conservate
      // in _allOptions (ricostruito se Dawn ha ri-renderizzato la select).
      if (
        !selectEl._allOptions ||
        (selectEl.options.length > 0 && selectEl._allOptions.indexOf(selectEl.options[0]) === -1)
      ) {
        selectEl._allOptions = Array.from(selectEl.options);
      }
      var valorePrecedente = selectEl.value;
      var opzioniCategoria = selectEl._allOptions.filter(function (o) {
        return (o.getAttribute('data-categoria') || 'altro') === categoria;
      });
      while (selectEl.options.length > 0) selectEl.remove(0);
      opzioniCategoria.forEach(function (o) {
        o.disabled = false;
        selectEl.appendChild(o);
      });

      var targetValue = null;
      if (misuraCorretta) {
        var matchInCat = opzioniCategoria.find(function (o) {
          return o.value === misuraCorretta;
        });
        if (matchInCat) targetValue = misuraCorretta;
      }
      if (!targetValue) {
        var primo = opzioniCategoria.find(function (o) {
          return o.value === valorePrecedente;
        }) || opzioniCategoria[0];
        if (primo) targetValue = primo.value;
      }

      if (targetValue) {
        selectEl.value = targetValue;
        // Dawn (updateSelectionMetadata) cerca l'opzione con attributo "selected"
        selectEl._allOptions.forEach(function (o) {
          if (o.value === targetValue) o.setAttribute('selected', 'selected');
          else o.removeAttribute('selected');
        });
      }

      if (targetValue && valorePrecedente !== targetValue) {
        var variantJson = document.querySelector('[data-selected-variant]');
        var variantCorrente = variantJson ? JSON.parse(variantJson.textContent) : null;
        var misuraGiaCorretta =
          variantCorrente && variantCorrente.options && variantCorrente.options[optionIndex] === targetValue;
        if (daUtente || !misuraGiaCorretta) {
          selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    // Mobile custom <select>
    var mobileSelect = document.querySelector('[data-misura-mobile-select][data-option-index="' + optionIndex + '"] select');
    if (mobileSelect) {
      if (!mobileSelect._allOptions) {
        mobileSelect._allOptions = Array.from(mobileSelect.options).map(function (opt) {
          return opt.cloneNode(true);
        });
      }

      while (mobileSelect.options.length > 0) mobileSelect.remove(0);
      mobileSelect._allOptions.forEach(function (opt) {
        var cat = opt.getAttribute('data-categoria') || 'altro';
        if (cat === categoria) mobileSelect.appendChild(opt.cloneNode(true));
      });

      var matchIdx = misuraCorretta
        ? Array.from(mobileSelect.options).findIndex(function (o) {
            return o.value.trim().toLowerCase() === misuraCorretta.trim().toLowerCase();
          })
        : -1;

      if (matchIdx >= 0) {
        mobileSelect.selectedIndex = matchIdx;
      } else if (mobileSelect.options.length > 0 && !misuraCorretta) {
        mobileSelect.selectedIndex = 0;
        var dawnSelect = document.getElementById('Option-' + sectionId + '-' + optionIndex);
        if (dawnSelect && dawnSelect.value !== mobileSelect.value) {
          impostaValoreDesktop(dawnSelect, mobileSelect.value);
          dawnSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }

  function sincronizzaMobileConVariant(sectionId, optionIndex) {
    var mobileSelect = document.querySelector('[data-misura-mobile-select][data-option-index="' + optionIndex + '"] select');
    if (!mobileSelect) return;

    var misuraCorretta = getMisuraFromVariant(sectionId, optionIndex);
    if (!misuraCorretta) return;

    var mapEl = document.getElementById('misura-map-' + sectionId);
    if (!mapEl) return;
    var map;
    try {
      map = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }

    var categoriaCorretta = map[misuraCorretta];
    if (!categoriaCorretta) return;

    var filterEl = document.querySelector('[data-misura-filter][data-section-id="' + sectionId + '"]');
    if (filterEl) {
      filterEl.querySelectorAll('.misura-categoria-btn').forEach(function (b) {
        b.classList.toggle('active', b.dataset.categoria === categoriaCorretta);
      });
      categoriaAttiva[sectionId] = { categoria: categoriaCorretta, optionIndex: optionIndex };
    }

    applicaFiltro(sectionId, optionIndex, categoriaCorretta);
  }

  function initMobileSelectListener(sectionId, optionIndex) {
    var mobileSelect = document.querySelector('[data-misura-mobile-select][data-option-index="' + optionIndex + '"] select');
    if (!mobileSelect || mobileSelect._listenerAggiunto) return;
    mobileSelect._listenerAggiunto = true;
    mobileSelect.addEventListener('change', function () {
      var dawnSelect = document.getElementById('Option-' + sectionId + '-' + optionIndex);
      if (dawnSelect) {
        impostaValoreDesktop(dawnSelect, mobileSelect.value);
        dawnSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // La select desktop contiene solo le opzioni della categoria attiva: se il
  // valore richiesto non c'è, rimette l'opzione prima di selezionarla, così
  // la select non resta mai senza valore (Dawn andrebbe in errore).
  function impostaValoreDesktop(selectEl, valore) {
    var presente = Array.from(selectEl.options).some(function (o) {
      return o.value === valore;
    });
    if (!presente && selectEl._allOptions) {
      var opzione = selectEl._allOptions.find(function (o) {
        return o.value === valore;
      });
      if (opzione) {
        opzione.disabled = false;
        selectEl.appendChild(opzione);
      }
    }
    selectEl.value = valore;
  }

  // show_misura_filter spento: niente pulsanti categoria, la select mobile
  // sincronizza comunque la select Dawn, senza filtrare
  function initMobileSelectSenzaFiltro() {
    document.querySelectorAll('[data-misura-mobile-select]').forEach(function (wrapper) {
      var optionIndex = wrapper.dataset.optionIndex;
      var mobileSelectEl = wrapper.querySelector('select');
      if (!mobileSelectEl || mobileSelectEl._listenerAggiunto) return;

      var idParts = mobileSelectEl.id.replace('Option-mobile-', '').split('-');
      idParts.pop();
      var sectionId = idParts.join('-');

      var hasFilter = document.querySelector('[data-misura-filter][data-section-id="' + sectionId + '"]');
      if (hasFilter) return;

      mobileSelectEl._listenerAggiunto = true;
      mobileSelectEl.addEventListener('change', function () {
        var dawnSelect = document.getElementById('Option-' + sectionId + '-' + optionIndex);
        if (dawnSelect) {
          Array.from(dawnSelect.options).forEach(function (o) {
            o.disabled = false;
          });
          impostaValoreDesktop(dawnSelect, mobileSelectEl.value);
          dawnSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      // sincronizza il valore iniziale dalla variante selezionata
      var misuraCorretta = getMisuraFromVariant(sectionId, parseInt(optionIndex));
      if (misuraCorretta) {
        var matchIdx = Array.from(mobileSelectEl.options).findIndex(function (o) {
          return o.value.trim().toLowerCase() === misuraCorretta.trim().toLowerCase();
        });
        if (matchIdx >= 0) {
          mobileSelectEl.selectedIndex = matchIdx;
        }
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-misura-filter]').forEach(function (filterEl) {
      var sectionId = filterEl.dataset.sectionId;
      var optionIndex = filterEl.dataset.optionIndex;

      var savedCat = categoriaAttiva[sectionId] ? categoriaAttiva[sectionId].categoria : null;
      var activeBtn = null;

      if (savedCat) {
        activeBtn = filterEl.querySelector('.misura-categoria-btn[data-categoria="' + savedCat + '"]');
        if (activeBtn) {
          filterEl.querySelectorAll('.misura-categoria-btn').forEach(function (b) {
            b.classList.remove('active');
          });
          activeBtn.classList.add('active');
        }
      }

      if (!activeBtn) {
        activeBtn = filterEl.querySelector('.misura-categoria-btn.active') || filterEl.querySelector('.misura-categoria-btn');
      }
      if (!activeBtn) return;

      var categoria = activeBtn.dataset.categoria;
      var categoriaUrl = getCategoriaFromVariant(sectionId);
      if (categoriaUrl && !savedCat) {
        categoria = categoriaUrl;
        filterEl.querySelectorAll('.misura-categoria-btn').forEach(function (b) {
          b.classList.toggle('active', b.dataset.categoria === categoria);
        });
      }

      categoriaAttiva[sectionId] = { categoria: categoria, optionIndex: optionIndex };
      applicaFiltro(sectionId, optionIndex, categoria);
      initMobileSelectListener(sectionId, optionIndex);

      if (!listenersAggiunti[sectionId]) {
        listenersAggiunti[sectionId] = true;
        filterEl.querySelectorAll('.misura-categoria-btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            filterEl.querySelectorAll('.misura-categoria-btn').forEach(function (b) {
              b.classList.remove('active');
            });
            btn.classList.add('active');
            var cat = btn.dataset.categoria;
            categoriaAttiva[sectionId] = { categoria: cat, optionIndex: optionIndex };
            applicaFiltro(sectionId, optionIndex, cat, true);
          });
        });
      }
    });
  }

  function runAll() {
    var variantJson = document.querySelector('[data-selected-variant]');
    if (!variantJson) {
      setTimeout(runAll, 200);
      return;
    }

    document.querySelectorAll('[data-misura-filter]').forEach(function (filterEl) {
      sincronizzaMobileConVariant(filterEl.dataset.sectionId, filterEl.dataset.optionIndex);
    });

    init();
    initMobileSelectSenzaFiltro();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    // con defer lo script parte a readyState 'interactive': filtra subito,
    // senza lasciare a Safari 500ms con tutte le option visibili
    runAll();
    setTimeout(runAll, 500);
  }

  // Rifiltra appena Dawn inserisce un nuovo <variant-selects> (re-render dopo
  // il cambio variante): Safari mostra le option non filtrate finché non si rifiltra
  function contieneVariantSelects(node) {
    if (node.nodeType !== 1) return false;
    return node.tagName === 'VARIANT-SELECTS' || !!node.querySelector('variant-selects');
  }

  new MutationObserver(function (mutations) {
    var inserito = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(contieneVariantSelects);
    });
    if (inserito) runAll();
  }).observe(document.documentElement, { childList: true, subtree: true });

  // rete di sicurezza se il MutationObserver non scatta
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(runAll, 300);
    });
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(runAll, 100);
  });
})();
